import { Module } from '@nestjs/common';
import { AlertasEmpresaController } from './alertas-empresa.controller';
import { AlertasEmpresaService } from './alertas-empresa.service';

@Module({
  controllers: [AlertasEmpresaController],
  providers: [AlertasEmpresaService],
  exports: [AlertasEmpresaService],
})
export class AlertasEmpresaModule {}
